import { PerkPriorityEnum } from '../../../../../shared/venue-features-enum';
import { difference } from '../../../../../shared/array-helpers';

const sortFeatureIcons = (features = []) => {
  const priority = features.filter(f => Object.keys(PerkPriorityEnum).includes(f)) || [];
  return [
    ...priority.sort((a, b) => {
      if (PerkPriorityEnum[a] < PerkPriorityEnum[b]) return -1;
      if (PerkPriorityEnum[b] < PerkPriorityEnum[a]) return 1;
      return 0;
    }),
    ...difference(features, priority),
  ];
};

export default sortFeatureIcons;
